import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'cnpj'
})
export class CNPJFormatPipe implements PipeTransform {

  transform(value: string, args?: any): any {
    if (value) {
      console.log(value)
      value = value.substr(0, 2) + '.' +
        value.substr(2, 3) + '.' +
        value.substr(5, 3) + '/' +
        value.substr(8, 4) + '-' +
        value.substr(12, 2)
    }
    return value;
  }
}
